export default "__VITE_ASSET__DOMd_wTc__"